import type { Chart as ChartJS } from 'chart.js';

const primaryBlue = getComputedStyle(document.documentElement)
    .getPropertyValue('--color-primary-blue')
    .trim();

const drawAxisArrows = (chart: ChartJS) => {
    const ctx = chart.ctx;
    const xAxis = chart.scales.x;
    const yAxis = chart.scales.y;

    ctx.save();
    ctx.globalCompositeOperation = 'destination-over';
    ctx.strokeStyle = primaryBlue;
    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.imageSmoothingEnabled = true;
    ctx.imageSmoothingQuality = 'high';

    // Draw X-axis arrow (right end) - two lines forming arrow
    const xEnd = xAxis.right;
    const xY = xAxis.top;

    ctx.beginPath();
    // Top line of arrow
    ctx.moveTo(xEnd - 8, xY - 8);
    ctx.lineTo(xEnd, xY - 1);
    // Bottom line of arrow
    ctx.moveTo(xEnd - 8, xY + 8);
    ctx.lineTo(xEnd, xY + 1);
    ctx.stroke();

    // Draw Y-axis arrow (top end) - two lines forming arrow
    const yX = yAxis.right;
    const yTop = yAxis.top;

    ctx.beginPath();
    // Left line of arrow
    ctx.moveTo(yX - 8, yTop + 8);
    ctx.lineTo(yX - 1, yTop);
    // Right line of arrow
    ctx.moveTo(yX + 8, yTop + 8);
    ctx.lineTo(yX + 1, yTop);
    ctx.stroke();

    ctx.restore();
};

export const axisArrowsPlugin = {
    id: 'axisArrows',
    afterDraw: drawAxisArrows,
};
